import { Button } from "@ui/Button";
import { Card } from "@ui/Card";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { Pill } from "@ui/Pill";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { For, Show } from "solid-js";
import { formatMoney, viewerIsSubscribed } from "../askPageAccess";
import { sortPrices, TIER_COPY, TYPE_LABEL } from "../askPageTiers";
import { type AskPagePrice, askPageVars } from "../pageVars";

type Props = {
	onJoin: (type: AskPagePrice["type"]) => void;
	id?: string;
};

export const TierRow = (props: Props) => {
	const vars = askPageVars();
	const prices = () => sortPrices(vars.prices);

	return (
		<Show
			when={
				vars.is_paid_ask_page &&
				vars.has_enabled_source &&
				vars.prices.length > 0 &&
				!viewerIsSubscribed(vars.status)
			}
		>
			<div class="askgvt1-tiers" id={props.id}>
				<div class="askgvt1-tiers-head">
					<Text family="mono" size="xsmall" color="fg3" transform="uppercase">
						Creator subscriptions
					</Text>
					<span class="askgvt1-tiers-rule" />
					<Text size="small" color="fg3">
						Time-based passes
					</Text>
				</div>
				<div class="askgvt1-tiers-grid">
					<For each={prices()}>
						{(price) => {
							const popular = () => price.type === "subscription";
							const money = () =>
								formatMoney(price.amount_minor, price.currency);
							const copy = TIER_COPY[price.type];

							return (
								<Card
									class="askgvt1-tier"
									classList={{ "askgvt1-tier--popular": popular() }}
								>
									<VStack spacing="large" fullHeight>
										<VStack spacing="small">
											<HStack
												align="center"
												justify="space-between"
												spacing="small"
												fullWidth
											>
												<Text
													as="span"
													size="medium-large"
													weight="semi-bold"
													color="ink"
												>
													{TYPE_LABEL[price.type]}
												</Text>
												<Show when={popular()}>
													<Pill theme="purple" variant="contrast" size="xsmall">
														Most popular
													</Pill>
												</Show>
											</HStack>
											<div class="askgvt1-tier-price">
												<Text
													family="display"
													size="xlarge"
													weight="bold"
													color="ink"
												>
													{money()}
												</Text>
												<Text size="small" color="fg3">
													{popular() ? "/ monthly" : "one-off"}
												</Text>
											</div>
										</VStack>
										<Text size="small" color="fg3">
											{copy.blurb}
										</Text>
										<div class="askgvt1-tier-perks">
											<For each={copy.perks(vars.influencer_display_name)}>
												{(perk) => (
													<span>
														<MaterialSymbol
															symbol="check"
															color="purple"
															relativeSize={0.85}
														/>
														<Text as="span" size="small" color="fg2">
															{perk}
														</Text>
													</span>
												)}
											</For>
										</div>
										<Button
											type="button"
											variant={popular() ? "primary" : "tertiary"}
											theme={popular() ? "purple" : undefined}
											fullWidth
											onClick={() => props.onJoin(price.type)}
										>
											{popular()
												? `Subscribe · ${money()}`
												: `Buy · ${money()}`}
										</Button>
									</VStack>
								</Card>
							);
						}}
					</For>
				</div>
			</div>
		</Show>
	);
};
